// authContext.jsx
import React, { createContext, useState, useContext, useEffect } from 'react';
import authService from '../services/authService';

// 創建認證上下文
const AuthContext = createContext();

// 測試用戶數據
const TEST_USERS = [
    {
        username: 'admin',
        password: 'admin123',
        user_id: 1,
        user_type: 'admin',
        full_name: '系統管理員',
        email: 'admin@smartride.com',
    },
    {
        username: 'manager',
        password: 'manager123',
        user_id: 2,
        user_type: 'manager',
        fleet_id: 1,
        fleet_name: '北區車隊',
        full_name: '車隊經理',
        email: 'manager@smartride.com',
    },
    {
        username: 'dispatcher',
        password: 'dispatch123',
        user_id: 3,
        user_type: 'dispatcher',
        dispatcher_id: 1,
        fleet_id: 1,
        fleet_name: '北區車隊',
        full_name: '調度員',
        email: 'dispatcher@smartride.com',
    }
];

export const AuthProvider = ({ children }) => {
    // 檢查是否在測試模式
    const isTestMode = process.env.REACT_APP_TEST_MODE === 'true' || localStorage.getItem('test_mode') === 'true';

    // 狀態用於儲存已認證用戶的資訊
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    // 元件掛載時檢查儲存的認證信息
    useEffect(() => {
        const initAuth = async () => {
            const storedUser = localStorage.getItem('user');
            const storedToken = localStorage.getItem('token');

            if (storedUser && storedToken) {
                setUser(JSON.parse(storedUser));
            }

            setLoading(false);
        };

        initAuth();
    }, []);

    // 登入函數
    const login = async (username, password) => {
        setLoading(true);

        try {
            // 如果啟用測試模式，使用模擬認證
            if (isTestMode) {
                const foundUser = TEST_USERS.find(
                    user => user.username === username && user.password === password
                );

                if (foundUser) {
                    // 創建一個不含密碼的副本
                    const { password, ...userWithoutPassword } = foundUser;
                    // 儲存用戶和假 token
                    localStorage.setItem('user', JSON.stringify(userWithoutPassword));
                    localStorage.setItem('token', 'test-token-' + Math.random().toString(36).substring(2));
                    setUser(userWithoutPassword);
                    setLoading(false);
                    return userWithoutPassword;
                } else {
                    throw new Error('帳號或密碼錯誤');
                }
            } else {
                // 生產模式下的真實 API 調用
                const response = await authService.login(username, password);
                localStorage.setItem('user', JSON.stringify(response.user));
                localStorage.setItem('token', response.token);
                setUser(response.user);
                setLoading(false);
                return response.user;
            }
        } catch (error) {
            setLoading(false);
            throw error;
        }
    };

    // 登出函數
    const logout = () => {
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        setUser(null);
    };

    // 啟用/禁用測試模式
    const toggleTestMode = (enabled) => {
        if (enabled) {
            localStorage.setItem('test_mode', 'true');
        } else {
            localStorage.removeItem('test_mode');
        }
        // 強制頁面重新載入以應用變更
        window.location.reload();
    };

    return (
        <AuthContext.Provider
            value={{
                user,
                login,
                logout,
                loading,
                isTestMode,
                toggleTestMode
            }}
        >
            {children}
        </AuthContext.Provider>
    );
};

export default AuthContext;